import React, { Component } from "react";
import { Link } from "react-router";

export default class Roster extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="aboss__intro-roster">
        <div className="aboss__intro-roster-container">
          <h1>ABOSS Roster</h1>
          <h2>Selection of artists being booked through ABOSS</h2>
          <Link to="/roster">
            <button>View roster</button>
          </Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/introduction/components/roster.js